<app-programtitle title="Find whether a given character is a vowel or consonant"></app-programtitle>
<p> Write a program to find whether a given character is a vowel or not. The vowels are 'a','e','i','o','u' </p>
<app-editor code="{{program}}"> </app-editor>